import { createTheme, responsiveFontSizes } from '@material-ui/core';

import muiTheme, { overridesMuiTheme } from './muiTheme';
import appTheme from './appTheme';

const applyTheme = () => {
  let theme = createTheme({ ...muiTheme, ...overridesMuiTheme });
  theme = responsiveFontSizes(theme);
  const fullTheme = { ...theme, app: { ...appTheme } };
  return fullTheme;
};

export default applyTheme;
